


















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import { SendPacket } from '../../networking/SendPacket';
import { PacketType } from '../../models/Packet';
import Timeline from '../../models/Timeline';
import ProjectServer from '@/models/ProjectServer'
import TimelineAccess from '../../models/TimelineAccess';
import Project from '../../models/Project';
import TimelineAccessUserData from '../../models/TimelineAccessUserData';
import store from '@/store/store'
import BestFitText from "@/components/BestFitText.vue";

class UserProjectAccess
{
    userid=""
    username=""
    display_name : string | null = null
    email=""
    userGroupID=-1
    
    public get uiName()
	{
		return this.display_name || this.username;
	}
}

@Component({
    components: 
    {
        BestFitText
    },
	computed: {
		...mapGetters([
            'checkTimelineAdmin'
		])
    },
    recomputed: {
        accessList(){
            let tg = this as TimelinePermissions;
            return tg.timeline.accessList;
        }
    }
})

export default class TimelinePermissions extends Vue {
    @Prop(Timeline) readonly timeline! : Timeline;

    get project() : Project
    {
        return this.$store.state.project.project as Project;
    }

    getAccessListRequest = -1;
    recomputeRequest = -1;

    user_filter= "";
    tl_user_filter= "";
    usergroups = [
        { id: 1, name: "View Only" },
        { id: 2, name: "Share & View" },
        { id: 3, name: "Edit & Share" },
        { id: 4, name: "Timeline Admin" },
    ]

    project_users : UserProjectAccess[] = []
    loading_project_users = false
    get loading(){
        return this.loading_project_users || this.getAccessListRequest != -1;
    }

    get filteredProjectList()
    {
        let res : TimelineAccess[] = [];

        let trimmed = this.user_filter.trim().toLowerCase();
        let accessList = (this as any).accessList as Map<string, TimelineAccess>;
        for(let user of this.project_users)
        {
            let access = accessList.get(user.userid.toLowerCase());
            if ((access == null || access.Permission == 0) && (trimmed.length == 0 || user.uiName.toLowerCase().includes(trimmed)))
            {
                let tacc = new TimelineAccess;
                tacc.Permission = 0;
                this.$set(tacc, 'User', new TimelineAccessUserData);
                tacc.User.userid = user.userid;
                tacc.User.username = user.username;
                tacc.User.display_name = user.display_name;
                tacc.User.email = user.email;
                tacc.User.currentUser = this.user.userid == user.userid;
                (tacc.User as any).isAdmin = user.userGroupID == 1;
                res.push(tacc);
            }
        }
        /*
        for(let kv of (this as any).accessList as Map<string, TimelineAccess>)
        {
            let access = kv[1];
            if (access.Permission == 0 && (trimmed.length == 0 || access.User.username.toLowerCase().includes(trimmed)))
            {
                res.push(access);
            }
        }
        */

        res.sort((a, b)=>{
            var textA = a.User.uiName.toLowerCase().trim();
            var textB = b.User.uiName.toLowerCase().trim();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })

        return res;
    }

    get filteredAccessList()
    {
        let res : TimelineAccess[] = [];

        let trimmed = this.tl_user_filter.trim().toLowerCase();
        for(let kv of (this as any).accessList as Map<string, TimelineAccess>)
        {
            let access = kv[1];
            if (access.Permission > 0 && (trimmed.length == 0 || access.User.uiName.toLowerCase().includes(trimmed)))
                res.push(access);
        }

        res.sort((a, b)=>{
            var textA = a.User.uiName.toLowerCase().trim();
            var textB = b.User.uiName.toLowerCase().trim();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })

        return res;
    }

    mounted(){
        this.refresh();
        this.recomputeRequest = ProjectServer.instance.registerCallback(PacketType.TimelineUpdateAccess, (data : any)=>{
            // TODO: This is a reactivity hack.  We need to look into why the vuex store is, in many cases, not properly reacting to changes in the data store.
            this.$recompute('accessList');
        });
    }

    beforeDestroy(){
        if (ProjectServer.instance.removeCallback(PacketType.TimelineUpdateAccess, this.recomputeRequest))
        {
            this.recomputeRequest = -1;
        }
        else
        {
            let pid = this.project.id;
            console.error(`TimelinePermissions: Failed to unsubscribe from recompute event.  Please report this error to admin@cliovis.com along with the following information: uid: ${this.user.userid}, pid: ${pid}, tid: ${this.timeline.id}`);
        }
    }

    async refresh(){
        this.project_users.length = 0;
        console.log('Requesting timeline access list');
        this.getAccessListRequest = ProjectServer.instance.registerCallback(PacketType.GetTimelineAccessList,
            (data : any)=>{
                this.$nextTick(()=>{
                    console.log('Recomputing access list');
                    this.$recompute('accessList');
                })
                if (data.timelineid === this.timeline.id)
                {
                    if (ProjectServer.instance.removeCallback(PacketType.GetTimelineAccessList, this.getAccessListRequest))
                    {
                        this.getAccessListRequest = -1;
                    }
                    else
                    {
                        console.error('Failed to unsubscribe from callback');
                    }
                }
            }
        );
        
        console.log('sending packet');
        SendPacket(PacketType.GetTimelineAccessList, {
            timelineid: this.timeline.id
        });

        this.loading_project_users=true;
        console.log('about to load project users');
        try
        {
            console.log('loading');
            let resp = await this.$http.get(`viewprojectusers?pid=${this.project.id}`);
            console.log('loading complete');
            let data = resp.data;
            if (data.error)
            {
                throw {response: resp};
            }
            
            let users = data.users as UserProjectAccess[] | undefined;
            if (!users)
            {
                throw {response: {data: {error: "Failed to read user array"}}};
            }
            
            for(let i = 0; i < data.users.length; ++i)
            {
                let obj = new UserProjectAccess;
                obj = Object.assign(obj, data.users[i]);
                this.project_users.push(obj);
            }
        }
        catch(err)
        {
            console.error(`Failed to load project users: ${err.response.data.error}`);
        }
        this.loading_project_users=false;
    }

    addUser(access : TimelineAccess)
    {
        let newAccess = new TimelineAccess;
        newAccess = Object.assign(newAccess, access);
        newAccess.Permission = 3;

        SendPacket(PacketType.TimelineUpdateAccess, {
            timelineid: this.timeline.id,
            access: newAccess
        });
    }

    removeUser(access : TimelineAccess)
    {
        let newAccess = new TimelineAccess;
        newAccess = Object.assign(newAccess, access);
        newAccess.Permission = 0;

        SendPacket(PacketType.TimelineUpdateAccess, {
            timelineid: this.timeline.id,
            access: newAccess
        });
    }

    changeUserGroup(access : TimelineAccess, value : number)
    {
        SendPacket(PacketType.TimelineUpdateAccess, {
            timelineid: this.timeline.id,
            access: access
        });
    }

    shouldDisplayEmail(email : string)
    {
        return !store.state.isLTI;
    }
}
